module.exports = __webpack_public_path__ + "img/product_category_preview_image-3.9d786a4.jpg";